export enum BonusType {
  DISCOUNT="discount",
  CHECK_LIST="check_list",
  PRICE_LIST="price_list",
  CATALOG="catalog",
  VIDEO="video",
  COUPON="coupon",
  GIFT="gift"
}
